import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    warningContainer: {
        padding: theme.spacing(2),
        borderRadius: 10,
        maxWidth: 220,
        display: "flex",
        gap: theme.spacing(1),
        alignItems: "center",
        justifyContent: "flex-start",
    },
    warningTitlesBox: {
        display: "flex",
        flexDirection: "column",
    },
    warningTitle: {
        color: theme.palette.error.main,
        fontSize: `10px !important`,
        textAlign: "left",
    },
    icon: {
        color: `${theme.palette.error.main} !important`,
        width: "30px !important",
        height: "30px !important",
    },
}));
